/* src/app/settings/pages/settings/settings.component.scss */
/*# sourceMappingURL=settings.component.css.map */
